/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserListUpdate
 */
export interface UserListUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof UserListUpdate
     */
    userImage?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserListUpdate
     */
    userEmployeeId?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserListUpdate
     */
    userLastName?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserListUpdate
     */
    userFirstName?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserListUpdate
     */
    userJobTitle?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserListUpdate
     */
    userNfcTokenDescription?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserListUpdate
     */
    userNfcToken?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserListUpdate
     */
    userFleetRole?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserListUpdate
     */
    userLicenseExpiryDate?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserListUpdate
     */
    userExpiryLogout?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserListUpdate
     */
    departmentLabel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserListUpdate
     */
    shiftLabel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserListUpdate
     */
    siteLabel?: boolean | null;
}

/**
 * Check if a given object implements the UserListUpdate interface.
 */
export function instanceOfUserListUpdate(value: object): value is UserListUpdate {
    return true;
}

export function UserListUpdateFromJSON(json: any): UserListUpdate {
    return UserListUpdateFromJSONTyped(json, false);
}

export function UserListUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserListUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'userImage': json['userImage'] == null ? undefined : json['userImage'],
        'userEmployeeId': json['userEmployeeId'] == null ? undefined : json['userEmployeeId'],
        'userLastName': json['userLastName'] == null ? undefined : json['userLastName'],
        'userFirstName': json['userFirstName'] == null ? undefined : json['userFirstName'],
        'userJobTitle': json['userJobTitle'] == null ? undefined : json['userJobTitle'],
        'userNfcTokenDescription': json['userNfcTokenDescription'] == null ? undefined : json['userNfcTokenDescription'],
        'userNfcToken': json['userNfcToken'] == null ? undefined : json['userNfcToken'],
        'userFleetRole': json['userFleetRole'] == null ? undefined : json['userFleetRole'],
        'userLicenseExpiryDate': json['userLicenseExpiryDate'] == null ? undefined : json['userLicenseExpiryDate'],
        'userExpiryLogout': json['userExpiryLogout'] == null ? undefined : json['userExpiryLogout'],
        'departmentLabel': json['departmentLabel'] == null ? undefined : json['departmentLabel'],
        'shiftLabel': json['shiftLabel'] == null ? undefined : json['shiftLabel'],
        'siteLabel': json['siteLabel'] == null ? undefined : json['siteLabel'],
    };
}

export function UserListUpdateToJSON(json: any): UserListUpdate {
    return UserListUpdateToJSONTyped(json, false);
}

export function UserListUpdateToJSONTyped(value?: UserListUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userImage': value['userImage'],
        'userEmployeeId': value['userEmployeeId'],
        'userLastName': value['userLastName'],
        'userFirstName': value['userFirstName'],
        'userJobTitle': value['userJobTitle'],
        'userNfcTokenDescription': value['userNfcTokenDescription'],
        'userNfcToken': value['userNfcToken'],
        'userFleetRole': value['userFleetRole'],
        'userLicenseExpiryDate': value['userLicenseExpiryDate'],
        'userExpiryLogout': value['userExpiryLogout'],
        'departmentLabel': value['departmentLabel'],
        'shiftLabel': value['shiftLabel'],
        'siteLabel': value['siteLabel'],
    };
}

